// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MoneyCollectFilledSvg from "@ant-design/icons-svg/es/asn/MoneyCollectFilled";
import AntdIcon from '../components/AntdIcon';

var MoneyCollectFilled = function MoneyCollectFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectFilledSvg
  }));
};

MoneyCollectFilled.displayName = 'MoneyCollectFilled';
export default React.forwardRef(MoneyCollectFilled);